import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Chip,
  useMediaQuery,
  Box,
  Typography,
  useTheme,
  Icon,
  Stack,
} from "@mui/material";
import {
  ArrowDownward,
  FirstPage,
  LastPage,
  ChevronLeft,
  ChevronRight,
  Add,
  Refresh,
  Edit,
  Delete,
  PowerSettingsNew,
  ImageOutlined,
  MovieOutlined,
} from "@mui/icons-material";
import MaterialTable from "@material-table/core";
import { useSnackbar } from "notistack";
import fondo from "../../assets/fondo.svg";
import fe from "../../assets/FERROEXPRESO.svg";
import { RemMensaje } from "../../redux/actions/mensajes";
import { Logout } from "../../redux/actions/usuario";
import {
  GrabarNotificacion,
  EliminarNotificacion,
  GetNotificacionesAdmin,
} from "../../redux/actions/notificaciones";
import {
  getNotificaciones,
  getGrupos,
  getCargando,
  getMensaje,
} from "../../redux/selectors";
import { format as DateFormat } from "date-fns";
import Eliminar from "./eliminar";
import Difusion from "./difusion";

const AdminDifusion = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const ss = useMediaQuery(theme.breakpoints.down("sm")); //small screen
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const mensaje = useSelector((state) => getMensaje(state));
  const [selectedRow, setSelectedRow] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  // const [openView,setOpenView] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);

  React.useEffect(() => {
    dispatch(GetNotificacionesAdmin());
    document.body.style.backgroundImage = `url(${fondo})`;
    document.body.style.backgroundPositionX = 0;
    document.body.style.backgroundPositionY = 0;
    document.body.style.backgroundAttachment = "fixed";
    document.body.style.backgroundSize = "cover";
    document.body.style.overflow = "hidden";

    return function cleanup() {
      dispatch(RemMensaje());
    };
  }, []);

  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  const handleEdit = (data) => {
    setSelectedRow(data);

    setOpenEdit(true);
  };

  const handleDelete = (data) => {
    setSelectedRow(data);
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedRow(null);
  };
  const handleAceptDelete = () => {
    dispatch(EliminarNotificacion(selectedRow.Id));
    setOpenDelete(false);
    setSelectedRow(null);
  };
  const handleAceptEdit = (valor) => {
    let param = {
      Id: selectedRow ? selectedRow.Id : 0,
      Titulo: valor.titulo,
      Fecha: DateFormat(valor.fecha, "yyyy-MM-dd"),
      Vigencia: valor.dias,
      DirigidoA: valor.grupos.filter((x) => x.Id > 0),
      Hijos: valor.Imagenes,
      Eliminadas: valor.ImagenesEliminadas,
    };
    dispatch(GrabarNotificacion(param));

    setOpenEdit(false);
    setSelectedRow(null);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedRow(null);
  };

  const datos = useSelector((state) => getNotificaciones(state));
  const cargando = useSelector((state) => getCargando(state));
  const opcionGrupos = useSelector((state) => getGrupos(state));
  const components = React.useMemo(() => {
    return { Container: (props) => props.children };
  }, []);

  const ViewGrupos = (gr) => {
    return (
      gr &&
      gr.map((option) => (
        <Stack padding={0.25}>
          <Chip
            key={option.Id}
            label={
              option.Descripcion
                ? option.Descripcion
                : opcionGrupos && opcionGrupos.find((x) => x.Id === option.Id)
                ? opcionGrupos.find((x) => x.Id === option.Id).Descripcion
                : "Grupo eliminado"
            }
            value={option.Id}
            color="primary"
          />
        </Stack>
      ))
    );
  };
  return (
    <>
      <Grid
        container
        sx={{
          p: 4,
          overflow: "hidden",
        }}
      >
        <Grid size={12}>
          <MaterialTable
            title={
              <Box display="flex">
                <img width={160} src={fe} alt="FerroExpreso Pampeano" />{" "}
                <Box paddingLeft={10}>
                  <Typography variant="h6">
                    Administración de novedades
                  </Typography>
                </Box>
              </Box>
            }
            icons={{
              Search: React.forwardRef((props, ref) => (
                <Icon {...props} ref={ref}>
                  search_outlined
                </Icon>
              )),
              ResetSearch: React.forwardRef((props, ref) => (
                <Icon {...props} ref={ref}>
                  clear
                </Icon>
              )),
              FirstPage: React.forwardRef((props, ref) => (
                <FirstPage {...props} ref={ref} />
              )),
              LastPage: React.forwardRef((props, ref) => (
                <LastPage {...props} ref={ref} />
              )),
              NextPage: React.forwardRef((props, ref) => (
                <ChevronRight {...props} ref={ref} />
              )),
              PreviousPage: React.forwardRef((props, ref) => (
                <ChevronLeft {...props} ref={ref} />
              )),
              SortArrow: React.forwardRef((props, ref) => (
                <ArrowDownward {...props} ref={ref} />
              )),
            }}
            columns={[
              { field: "Id", hidden: true },
              {
                title: "",
                field: "IMG",
                render: (rowData) => {
                  return rowData.Src === "img" ? (
                    <img
                      style={{ maxHeight: 75, border: "1px #e0e0e0 solid" }}
                      src={rowData.IMG}
                    />
                  ) : (
                    <video
                      controls
                      style={{ maxHeight: 75, border: "1px #e0e0e0 solid" }}
                      src={rowData.IMG}
                    />
                  );
                },
                align: "center",
                cellStyle: { borderRight: "2px #eeeeee solid", padding: "8px" },
              },
              {
                title: "Titulo",
                field: "Titulo",
                cellStyle: {
                  fontWeight: "bold",
                  borderRight: "2px #eeeeee solid",
                  minWidth: "100%",
                },
              },
              {
                title: "Dirigido a...",
                field: "DirigidoA",
                render: (rowData) => {
                  return rowData.DirigidoA.length > 0 ? (
                    ViewGrupos(rowData.DirigidoA)
                  ) : (
                    <Chip key={0} color="secondary" label={"Todos"} value={0} />
                  );
                },
                align: "center",
                cellStyle: { borderRight: "2px #eeeeee solid", padding: "8px" },
              },
              {
                title: "Fecha",
                field: "Fecha",
                type: "date",
                align: "center",
                cellStyle: {
                  borderRight: "2px #eeeeee solid",
                  width: 0,
                  whiteSpace: "nowrap",
                },
              },
              {
                title: "Vigencia (Días)",
                field: "Vigencia",
                type: "numeric",
                align: "center",
                cellStyle: {
                  borderRight: "2px #eeeeee solid",
                  width: 0,
                  whiteSpace: "nowrap",
                },
              },
              {
                title: (
                  <Box display="flex">
                    <ImageOutlined />
                    <MovieOutlined />
                  </Box>
                ),
                field: "cantHijos",
                type: "numeric",
                align: "center",
                cellStyle: {
                  borderRight: "2px #eeeeee solid",
                  width: 0,
                  whiteSpace: "nowrap",
                },
              },
            ]}
            data={datos}
            actions={[
              {
                icon: React.forwardRef((props, ref) => (
                  <Add {...props} ref={ref} />
                )),
                tooltip: "Agregar",
                isFreeAction: true,
                onClick: (event, rowData) => handleEdit(null),
              },
              {
                icon: React.forwardRef((props, ref) => (
                  <Refresh {...props} ref={ref} />
                )),
                tooltip: "Actualizar",
                isFreeAction: true,
                onClick: (event, rowData) => dispatch(GetNotificacionesAdmin()),
              },
              {
                icon: React.forwardRef((props, ref) => (
                  <PowerSettingsNew {...props} ref={ref} color="secondary" />
                )),
                tooltip: "Cerrar sesión",
                isFreeAction: true,
                onClick: (event, rowData) => dispatch(Logout()),
              },
              {
                icon: React.forwardRef((props, ref) => (
                  <Edit {...props} ref={ref} />
                )),
                tooltip: "Editar",
                onClick: (event, rowData) => handleEdit(rowData),
              },
              {
                icon: React.forwardRef((props, ref) => (
                  <Delete {...props} ref={ref} />
                )),
                tooltip: "Borrar",
                onClick: (event, rowData) => {
                  handleDelete(rowData);
                },
              },
            ]}
            options={{
              tableLayout: "auto",
              searchAutoFocus: true,
              searchFieldStyle: { backgroundColor: "#FFF" },
              header: true,
              stickyHeader: true,
              sorting: true,
              selection: false,
              paging: true,
              grouping: false,
              pageSize: 10,
              pageSizeOptions: [5, 10, 25, 50, 100],
              emptyRowsWhenPaging: false,
              actionsColumnIndex: -1,
              searchFieldVariant: "outlined",
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.tableData.id % 2 === 1 ? "#FFF" : "#FAFAFA",
              }),
              headerStyle: {
                backgroundColor: theme.palette.primary.main,
                color: "#FFF",
              },
              maxBodyHeight: `calc(100vh - 180px)`,
              minBodyHeight: `calc(100vh - 180px)`,
            }}
            localization={{
              body: {
                emptyDataSourceMessage: "No hay datos para mostrar",
              },
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "filas",
                labelRowsPerPage: "Filas por página",
                firstAriaLabel: "Primer página",
                firstTooltip: "Primer página",
                previousAriaLabel: "Anterior",
                previousTooltip: "Página anterior",
                nextAriaLabel: "Siguiente",
                nextTooltip: "Siguiente página",
                lastAriaLabel: "Última página",
                lastTooltip: "Última página",
              },
              toolbar: {
                searchTooltip: "Filtrar listado",
                searchPlaceholder: "Búsqueda",
                exportTitle: "Exportar",
                exportCSVName: "Exportar como CSV",
                exportPDFName: "Exportar como PDF",
              },
              header: {
                actions: "",
              },
            }}
            components={components}
            isLoading={cargando}
          />
        </Grid>
      </Grid>
      {openDelete && (
        <Eliminar
          fullScreen={ss}
          open={openDelete}
          handleCloseDelete={handleCloseDelete}
          selectedRow={selectedRow}
          handleAceptDelete={handleAceptDelete}
        />
      )}
      {openEdit && (
        <Difusion
          fullScreen={ss}
          open={openEdit}
          handleCloseEdit={handleCloseEdit}
          opcionGrupos={opcionGrupos}
          handleAceptEdit={handleAceptEdit}
          row={selectedRow}
          theme={theme}
        />
      )}
    </>
  );
};

export default AdminDifusion;
